import {createContext} from 'react';

type VehicleWarehouseContextType = {
  refreshDataGrid: () => void;
  refreshTick: number;
};

export const VehicleWarehouseContext = createContext<VehicleWarehouseContextType | null>(null);
